import ExpandImage from "@/icons/components/ExpandImage";
import styles from "./styles.module.css";
import Image from "@/shared/components/Image/new";


const Img = ({ image, paragraph }) => {
  const { _id, dimensions } = image;
  const { value, epigraphe } = paragraph;

  const element = {
    images: [
      value &&
      {
        clippings: value.clippings || [],
        title: value.title || ""
      }
    ]
  }

  return (
    <div className={styles['article-image-epi']}>
      <Image
        element={element}
        clipping={_id}
        width={dimensions && dimensions.width}
        height={dimensions && dimensions.height}
        className={styles['cover-image']}
      />
      <span className={styles["epigraphe"]}>{epigraphe}</span>
      <hr />
      <span className={styles["img-expand"]}>
        <button className={styles["open-img"]} aria-label="Open Image">
          <ExpandImage />
        </button>
      </span>
    </div>
  );
}

export default Img;